import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { ContentTypes, HttpMethods, SERVICES } from '../../../services/api';
import { basicApiAsyncThunkCreator } from '../../../services/apiAsyncThunkCreator';
import { ThunkAPI } from '../../rootReducer';
import { IAddressElement } from '../../../components/accounts/modal/paymentAndBilling/address';
import { showErrorMessage, showSuccessMessage } from '../../notifications';
import { actions as AccountListActions } from '../list';

export interface IUpdateBillingArgs {
  accountId: string;
  billingAddress?: IAddressElement;
}

export const UPDATE_BILLING_ADDRESS_THUNK_PREFIX = 'updateBillingAddress';
export const updateBillingAddress: AsyncThunk<void, IUpdateBillingArgs, ThunkAPI> = createAsyncThunk(
  UPDATE_BILLING_ADDRESS_THUNK_PREFIX,
  async (data: IUpdateBillingArgs, thunk) => {
    try {
      const response = await basicApiAsyncThunkCreator<void, IUpdateBillingArgs>({
        endpoint: 'accounts/update-billing-address',
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Put,
        contentType: ContentTypes.ApplicationJson
      })(data, thunk);
      const successMessage = 'Billing address updated successfully.';
      thunk.dispatch(showSuccessMessage(successMessage));
      thunk.dispatch(AccountListActions.updateAccountBillingAddress(data));
      return response;
    } catch (err) {
      thunk.dispatch(showErrorMessage('An error occurred while updating the billing address'));
      return thunk.rejectWithValue(JSON.stringify(err) || 'An error occurred on updateBillingAddress');
    }
  }
);
